import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, pricing } from '../data/bonuses';
import { BonusCard } from './BonusCard';
export function Bonuses() {
  return <section id="bonuses" className="bg-navy px-4 py-12 md:py-16" data-id="element-30" data-mp="av36mvbir927">
      <div className="mx-auto max-w-3xl text-center" data-id="element-31" data-mp="autep26wyrtv">
        <GiftIcon className="mx-auto h-8 w-8 text-brand-light" aria-hidden="true" data-id="element-32" data-mp="ftmresedmesz" />
        <h2 className="mt-3 font-display text-xl font-black uppercase leading-tight text-white md:text-3xl" data-id="element-33" data-mp="1un4pqafc9zg">
          Includes <span className="text-brand-light" data-id="element-34" data-mp="5w8q6010xwl9">5 practical bonuses</span>
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-3xl space-y-4" data-id="element-35" data-mp="3o24v01rj7xub">
        {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-36" data-mp="3t06egnsvdz6b" />)}
        <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-brand-light/60 p-5 text-center" data-id="element-37" data-mp="3t2soqv75ass8">
          <p className="text-[11px] font-extrabold uppercase tracking-wider text-white/80" data-id="element-38" data-mp="1r936k6ad6ypg">Total bonus value</p>
          <span className="mt-1 font-display text-3xl font-black text-white/80 line-through decoration-red-500 decoration-4" data-id="element-39" data-mp="3idmyfw86v5fj">
            ${pricing.bonusValue} USD
          </span>
          <p className="mt-1 font-display text-base font-black uppercase text-brand-light" data-id="element-40" data-mp="3r6i7l10s1lal">
            All 5 bonuses included free
          </p>
        </div>
      </div>
    </section>;
}